import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BLService } from './bl.service';

@Injectable({ providedIn: 'root' })
export class FileVaultService extends BLService {
  private static RESOURCE_ENDPOINT = 'file-vault';

  public getAllFileNames(): Observable<string[]> {
    return this.httpGet<string[]>(FileVaultService.RESOURCE_ENDPOINT).pipe(
      catchError((error: unknown) => {
        if (error instanceof HttpErrorResponse && (error.status === 401 || error.status === 405)) {
          return of([]);
        }

        return throwError(() => error);
      }),
    );
  }

  public download(fileName: string): Observable<any> {
    const options = this.httpAuthHeader.getHeaderWithResponseType('arraybuffer');
    options.headers.delete('Content-Type');

    return this.httpGet<any>(`${FileVaultService.RESOURCE_ENDPOINT}/download/${fileName}`, options);
  }
}
